export default "__VITE_ASSET__DlQx034F__"